<template>
  <div :style="boxWrapStyleObj" class="nj-header-title" style="position: relative;">
      <div class="header-title-area" ref="statisTitle">
          <div class="area-title">
              <img src="../../../assets/images/nanjindataboard/right-row.png" />
              <p class="title-text">区域分布数</p>
          </div>
          <img src="../../../assets/images/nanjindataboard/bottom-bg.png" style="float: left" />
      </div>
      <div :style="contentStyleObj">
          <!--图例-->
          <div class="echart-legend" v-if="channel!='sy'">
              <div class="legend-item" @click="selectLegend('')">
                  <p class="legend-item-color" :style="
                      legendIndex == ''
                          ? { background: 'red' }
                          : { background: '#A2A2A2' }
                  "></p>
                  <p class="legend-item-text">全部</p>
              </div>
              <div class="legend-item" @click="selectLegend('1')">
                  <p class="legend-item-color" :style="
                      legendIndex == '' || legendIndex == '1'
                          ? { background: '#24C4DC' }
                          : { background: '#A2A2A2' }
                  "></p>
                  <p class="legend-item-text">小学</p>
              </div>
              <div class="legend-item" @click="selectLegend('2')">
                  <p class="legend-item-color" :style="
                      legendIndex == '' || legendIndex == '2'
                          ? { background: '#ED8167' }
                          : { background: '#A2A2A2' }
                  "></p>
                  <p class="legend-item-text">初中</p>
              </div>
              <div class="legend-item" @click="selectLegend('3')">
                  <p class="legend-item-color" :style="
                      legendIndex == '' || legendIndex == '3'
                          ? { background: '#FAE17C' }
                          : { background: '#ccc' }
                  "></p>
                  <p class="legend-item-text">高中</p>
              </div>
          </div>
          <!--区域分布数-->
          <div :padding="0">
              <!--图表-->
              <div :style="{ height: contentStyleObj.height }">
                  <div style="width: 100%; height: 100%" :id="'district_dis_data'"></div>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
import { queryNextRegionSchoolPhase } from "../../../service/api";
// import HistogramCharts from "@/components/charts/HistogramCharts.vue";//柱状图
// const newAgainHistogramCharts = () =>
//   import("../../../components/charts/newAgainHistogramCharts");

export default {
  name: "district-dis-statics",
  components: {
  },
  props: {
      screenHeight: Number,
      titleHeight: Number,
      areaCode: String,
      areaParams: Object,
      regionId:String,
      isTowns:String
  },
  data() {
      return {
          legendIndex: "",
          boxWrapStyleObj: {
              height: "",
          },
          contentStyleObj: {
              height: "",
          },
          tooltip: {},
          legend: {},
          xAxis: {},
          yAxis: {},
          channel: process.env.VUE_APP_CHANNEL,
      };
  },
  watch: {
      screenHeight: "initBoxHeight",
      titleHeight: "initBoxHeight",
  },
  methods: {
      /**
       * 根据区域编码获取下级区域中每个学段的学校数
       */
      async getNextRegionSchoolPhase() {
          let _this = this;
          let params = {
              provinceCode: _this.areaParams.provinceCode,
              cityCode: _this.areaParams.cityCode,
              districtCode: _this.areaParams.districtCode,
              phase: _this.legendIndex,
              regionId:_this.regionId,
              isTowns:_this.isTowns
          };
          let res = await queryNextRegionSchoolPhase(params);
          if (_this.channel != 'sy') {
              let xData = [];
              let primaryPhaseList = [];
              let juniorPhaseList = [];
              let highPhaseList = [];
              for (let i = 0; i < res.length; i++) {
                  xData.push(res[i].regionName);
                  for (let j = 0; j < res[i].regionInfo.length; j++) {
                      if (res[i].regionInfo[j].phase == '1') {
                          primaryPhaseList.push(res[i].regionInfo[j].schoolNum)
                      } else if (res[i].regionInfo[j].phase == '2') {
                          juniorPhaseList.push(res[i].regionInfo[j].schoolNum)
                      } else if (res[i].regionInfo[j].phase == '3') {
                          highPhaseList.push(res[i].regionInfo[j].schoolNum)
                      }
                  }
              }
              xData = xData.slice(0, 10)
              primaryPhaseList = primaryPhaseList.slice(0, 10)
              juniorPhaseList = juniorPhaseList.slice(0, 10)
              highPhaseList = highPhaseList.slice(0, 10)
              console.log(xData)
              console.log(primaryPhaseList)
              console.log(juniorPhaseList)
              console.log(highPhaseList)
              let seriesDataArr = [
                  {
                      name: "小学",
                      type: "bar",
                      stack: "phase",
                      color: "#24C4DC",
                      barWidth: "30",
                      barGap: "80%",
                      data: primaryPhaseList,
                  },
                  {
                      name: "初中",
                      type: "bar",
                      stack: "phase",
                      color: "#ED8167",
                      barWidth: "30",
                      barGap: "80%",
                      data: juniorPhaseList,
                  },
                  {
                      name: "高中",
                      type: "bar",
                      stack: "phase",
                      color: "#FAE17C",
                      barWidth: "30",
                      barGap: "80%",
                      data: highPhaseList,
                  },
              ];
              _this.getDsitrictDisData(xData, seriesDataArr);

          } else {

              let xdataArr = [];
              let seriesDataArr = [];
              for (let i = 0; i < res[0].regionInfo.length; i++) {
                  let phase_mame = res[0].regionInfo[i].phase == 1 ? '小学' : res[0].regionInfo[i].phase == 2 ? '初中' : '高中';
                  xdataArr.push(phase_mame);
                  seriesDataArr.push(res[0].regionInfo[i].schoolNum);
              }
              //渲染图表
              _this.initSyDsitrictDisData(xdataArr, seriesDataArr);
          }

      },

      /**
       * 图例切换
       */
      selectLegend(item) {
          this.legendIndex = item;
          this.getNextRegionSchoolPhase();
      },
      /**
       * 初始化box高度
       */
      initBoxHeight() {
          let winHeight = window.innerHeight;
          if (winHeight < 900) {
              winHeight = 938;
          }

          let boxWrapHeight = (winHeight - 128 - 10 - 30 - 20) / 3;
          let contentHeight =
              boxWrapHeight - this.$refs.statisTitle.offsetHeight - 20;
          this.boxWrapStyleObj.height = boxWrapHeight + "px";
          this.contentStyleObj.height = contentHeight + "px";
      },
      /**
       * 获取区域分布数据
       */
      getDsitrictDisData(xDataArr, seriesDataArr) {
          let _this = this;
          _this.legend = {
              show: true,
              data: ["小学", "初中", "高中"],
              right: "10",
              itemWidth: 14,
              itemHeight: 14,
              textStyle: {
                  color: "#708ACC",
                  fontSize: "14px",
              },
          };
          _this.xAxis = [
              {
                  type: "category",
                  show: true,
                  axisTick: { show: false },
                  axisLabel: {
                      interval: 0,
                      rotate: 40,
                      textStyle: {
                          color: "#708ACC", //颜色
                          fontSize: "16", //大小
                      },
                      //坐标轴刻度标签的相关设置。
                      formatter: function (params) {
                          var newParamsName = "";// 最终拼接成的字符串
                          // if (_this.isWrapData) {
                          var paramsNameNumber = params.length;// 实际标签的个数
                          var rowNumber = Math.ceil(paramsNameNumber / 6);// 换行的话，需要显示几行，向上取整
                          //判断标签的个数是否大于规定的个数， 如果大于，则进行换行处理 如果不大于，即等于或小于，就返回原标签
                          if (paramsNameNumber > 6) {
                              /** 循环每一行,p表示行 */
                              for (var p = 0; p < rowNumber; p++) {
                                  var tempStr = "";// 表示每一次截取的字符串
                                  var start = p * 6;// 开始截取的位置
                                  var end = start + 6;// 结束截取的位置
                                  // 此处特殊处理最后一行的索引值
                                  if (p == rowNumber - 1) {
                                      // 最后一次不换行
                                      tempStr = params.substring(start, paramsNameNumber);
                                  } else {
                                      // 每一次拼接字符串并换行
                                      tempStr = params.substring(start, end) + "\n";
                                  }
                                  newParamsName += tempStr;// 最终拼成的字符串
                              }

                          } else {
                              // 将旧标签的值赋给新标签
                              newParamsName = params;
                          }
                          // } else if (_this.isHideData) {
                          //     newParamsName = params.length > 5 ? params.substring(0, 5) + '...' : params;
                          // } else {
                          //     newParamsName = params;
                          // }
                          //将最终的字符串返回
                          return newParamsName
                      }
                  },
                  axisLine: {
                      show: true,
                      lineStyle: { color: "#6076AD" },
                  },
              },
          ];
          _this.yAxis = [
              {
                  type: "value",
                  show: true,
                  axisLabel: {
                      textStyle: {
                          color: "#708ACC", //颜色
                          fontSize: "16", //大小
                      },
                  },
                  axisLine: {
                      show: false,
                  },
                  splitLine: {
                      show: true,
                      lineStyle: {
                          color: "#6076AD",
                          opacity: 0.3,
                      },
                  },
              },
          ];
          (_this.tooltip = {
              show: true,
              trigger: "axis",
              axisPointer: {
                  // 坐标轴指示器，坐标轴触发有效
                  type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
              },
          }),
              this.$nextTick(() => {
                  //   setTimeout(function () {
                  // _this.$refs.districtDisRef.initDataSource(xDataArr, seriesDataArr);
                  _this.initDataSource(xDataArr, seriesDataArr);
                  //   }, 500);
              });
      },
      /**
       * @name 处理上虞的数据渲染图表
       */
      initSyDsitrictDisData(xDataArr, seriesDataArr) {
          let _this = this;

          let dataSource = _this.$echarts.init(
              document.getElementById('district_dis_data')
          );
          const option = {
              tooltip: {
                  trigger: "axis",
                  axisPointer: {
                      // 坐标轴指示器，坐标轴触发有效
                      type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
                  },
                  //自定义悬浮框内容
                  formatter: function (params) {
                      var color = '#1857c6';//图例颜色
                      var htmlStr = '<div>';
                      htmlStr += params[0].name + '<br/>';//x轴的名称
                      //添加圆点
                      htmlStr += '<span style="margin-right:5px;display:inline-block;width:10px;height:10px;border-radius:5px;background-color:' + color + ';"></span>';
                      //添加一个汉字，动态的自定义文本内容
                      htmlStr += params[0].value;
                      htmlStr += '</div>';
                      return htmlStr;
                  }
              },
              xAxis: {
                  type: "category",
                  data: xDataArr,
                  axisLabel: {
                      textStyle: {
                          color: '#757C8C', //颜色
                          fontSize: '12px'  //大小
                      }
                  }
              },
              yAxis: {
                  type: "value",
                  axisLabel: {
                      formatter: '{value}'
                  },
                  textStyle: {
                      color: '#757C8C', //颜色
                      fontSize: '12px'  //大小
                  }
              },
              // grid: {
              //     // left: 75,
              //     bottom: _this.bottomHeightLocal
              // },
              series: [
                  {
                      data: seriesDataArr,
                      type: 'bar',
                      itemStyle: {
                          normal: {
                              label: {
                                  show: false, //开启显示
                                  position:
                                      "top", //在上方显示
                                  textStyle:
                                  {
                                      //数值样式
                                      color: '#757C8C', //颜色
                                      fontSize: '12px'  //大小
                                  }
                                  ,
                                  formatter: function (params) {
                                      if (params.value > 1000) {
                                          let value = parseInt(params.value / 1000);
                                          return value + '千+';
                                      } else if (params.value > 10000) {
                                          let value = parseInt(params.value / 10000);
                                          return value + '万+';
                                      } else {
                                          return params.value;
                                      }
                                  }
                              }
                              ,
                              color: '#1857c6'
                          }
                      },
                      barWidth: "30",
                      barGap: "80%",
                  }
              ]
          }
              ;
          dataSource.setOption(option);
          window.addEventListener("resize", function () {
              dataSource.resize();
          });
      },
      /**
       * 加载图表数据
       */
      initDataSource(xDataArr, seriesDataArr) {
          let _this = this;
          let dataSource = _this.$echarts.init(
              document.getElementById("district_dis_data")
          );
          _this.xAxis[0].data = xDataArr;
          dataSource.off("click");
          const option = {
              tooltip: _this.tooltip,
              xAxis: _this.xAxis,
              yAxis: _this.yAxis,
              //距离上下左右的距离
              grid: {
                  left: "3%",
                  right: "4%",
                  bottom: "7%",
                  top: "7%",
                  containLabel: true,
              },
              series: seriesDataArr,
          };
          dataSource.setOption(option);
          window.addEventListener("resize", function () {
              dataSource.resize();
          });
      },
  },
  mounted() {
      this.getNextRegionSchoolPhase();
      this.initBoxHeight();
      let seriesDataArr = [
          {
              name: "小学",
              type: "bar",
              stack: "phase",
              color: "#24C4DC",
              barWidth: "30",
              barGap: "80%",
              data: [
                  "16",
                  "32",
                  "23",
                  "21",
                  "32",
                  "22",
                  "19",
                  "35",
                  "19",
                  "11",
                  "11",
              ],
          },
          {
              name: "初中",
              type: "bar",
              stack: "phase",
              color: "#ED8167",
              barWidth: "30",
              barGap: "80%",
              data: ["6", "7", "8", "8", "14", "2", "7", "12", "6", "1", "2"],
          },
          {
              name: "高中",
              type: "bar",
              stack: "phase",
              color: "#FAE17C",
              barWidth: "30",
              barGap: "80%",
              itemStyle: {
                  normal: {
                      //柱形图圆角，初始化效果
                      barBorderRadius: [4, 4, 0, 0],
                  },
              },
              data: ["2", "6", "2", "2", "4", "1", "3", "8", "3", "0", "0"],
          },
      ];
      //获取区域分布数据
      this.getDsitrictDisData(seriesDataArr);
  },
};
</script>

<style lang="scss" scoped>
@import "../../../style/databoard";
</style>